import React, { useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './ChooseCategory.css';

const ChooseCategory = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const goToParts = (cat) => {
    navigate(`/parts/front?variant=${encodeURIComponent(slug)}&category=${cat}`);
  };

  return (
    <div className="choose-category-page">
      <div className="category-page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/" className="breadcrumb-link">
              الرئيسية
            </Link>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">اختر التصنيف</span>
          </div>
          <h1 className="page-title">ماذا تريد استعراض؟</h1>
          <p className="page-subtitle">اختر كماليات أو قطع غيار لاستعراض الأجزاء المتاحة لسيارتك</p>
        </div>
      </div>
      <div className="container">
        <div className="category-cards">
          <button
            type="button"
            className="category-card category-card-accessories"
            onClick={() => goToParts('accessories')}
          >
            <span className="category-card-icon">✨</span>
            <h2 className="category-card-title">كماليات</h2>
            <p className="category-card-desc">استعراض الكماليات والأجزاء الداخلية والخارجية</p>
          </button>
          <button
            type="button"
            className="category-card category-card-parts"
            onClick={() => goToParts('parts')}
          >
            <span className="category-card-icon">🔧</span>
            <h2 className="category-card-title">قطع غيار</h2>
            <p className="category-card-desc">استعراض قطع الغيار الأصلية والمتوافقة</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseCategory;
